import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

const AfterSignup = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [counter, setCounter] = useState(5);

  const countDown = () => {
    if (counter === 0) {
      return;
    }
    setTimeout(() => {
      setCounter(counter - 1);
    }, 1000);

    return (
      <p className="auto-close">
        {t("this page will automatically close in")} {counter} {t("seconds")}
      </p>
    );
  };

  useEffect(() => {
    setTimeout(() => {
      navigate("/");
    }, 20000);
  });

  return (
    <div className="parent-conatainer-short">
      <div className="waiting-verification waiting">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <g id="SVGRepo_bgCarrier" strokeWidth={0} />
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g id="SVGRepo_iconCarrier">
            <circle
              style={{
                fill: "#ffffff",
              }}
              cx={256}
              cy={256}
              r={256}
            />
            <g>
              <path
                style={{
                  fill: "#CCCCCC",
                }}
                d="M105.86,346.256L244,258l-138.248-92.168c-3.488,2.94-5.752,7.28-5.752,12.168v156 C100,338.936,102.312,343.316,105.86,346.256z"
              />
              <path
                style={{
                  fill: "#CCCCCC",
                }}
                d="M406.252,165.832L268,258l138.14,88.256c3.548-2.94,5.86-7.32,5.86-12.256V178 C412,173.112,409.736,168.772,406.252,165.832z"
              />
            </g>
            <path
              style={{
                fill: "#E6E6E6",
              }}
              d="M256,242L105.652,346.084c2.8,2.404,6.392,3.916,10.348,3.916h280c3.956,0,7.548-1.508,10.348-3.916 L256,242z"
            />
            <path
              style={{
                fill: "#F5F5F5",
              }}
              d="M256,270l150.348-104.084c-2.8-2.404-6.392-3.916-10.348-3.916H116 c-3.956,0-7.548,1.508-10.348,3.916L256,270z"
            />
            <path
              style={{
                fill: "#ffffff",
              }}
              d="M408,416c-37.496,0-68-30.504-68-68s30.504-68,68-68s68,30.504,68,68S445.496,416,408,416z"
            />
            <circle
              style={{
                fill: "#66ab67",
              }}
              cx={408}
              cy={348}
              r={52}
            />
            <path
              style={{
                fill: "#F5F5F5",
              }}
              d="M400,368c-1.024,0-2.048-0.392-2.828-1.172l-16-16c-1.564-1.564-1.564-4.092,0-5.656 s4.092-1.564,5.656,0L400,358.344l29.172-29.172c1.564-1.564,4.092-1.564,5.656,0s1.564,4.092,0,5.656l-32,32 C402.048,367.608,401.024,368,400,368z"
            />
          </g>
        </svg>
        <h1>{t("success_signup_message_header")}</h1>
        <p>{t("success_signup_message")}</p>
        {/* {countDown()} */}
        <hr />
        <Link to="../">{t("done")}</Link>
      </div>
    </div>
  );
};

export default AfterSignup;
